import L from "leaflet";
import { COLORS_MERCADOS } from "./styleUtils";
import mercados_minoristas from "../assets/iconos/mercado_azul.png";
import minoristaVerde from "../assets/iconos/mercado_verde.png";
import mercados_mayoristas from "../assets/mayoristas.png";
import zonas_industriales from "../assets/zonas_.png";
import parques_industriales from "../assets/parques.png";

// New PNG Icons
import marron_0 from "../assets/iconos/marron_0.png";
import marron_1 from "../assets/iconos/marron_1.png";
import verde_0 from "../assets/iconos/verde_0.png";
import verde_1 from "../assets/iconos/verde_1.png";
import verde_2 from "../assets/iconos/verde_2.png";
import azul_0 from "../assets/iconos/azul_0.png";
import azul_1 from "../assets/iconos/azul_1.png";
import azul_2 from "../assets/iconos/azul_2.png";
import amarillo_0 from "../assets/iconos/amarillo_0.png";
import amarillo_1 from "../assets/iconos/amarillo_1.png";
import gris_0 from "../assets/iconos/gris_0.png";
import gris_1 from "../assets/iconos/gris_1.png";
import blanco_0 from "../assets/iconos/blanco_0.png";

const createIcon = (url) =>
  new L.Icon({
    iconUrl: url,
    iconRetinaUrl: url,
    iconSize: [19, 28],
    iconAnchor: [10, 10],
    popupAnchor: [0, -35],
    shadowUrl: null,
  });

export const iconMap = {
  "marron_0": marron_0,
  "marron_1": marron_1,
  "verde_0": verde_0,
  "verde_1": verde_1,
  "verde_2": verde_2,
  "azul_0": azul_0,
  "azul_1": azul_1,
  "azul_2": azul_2,
  "amarillo_0": amarillo_0,
  "amarillo_1": amarillo_1,
  "gris_0": gris_0,
  "gris_1": gris_1,
  "blanco_0": blanco_0
};

// Marker pulsante (divIcon CSS) — color tomado de la modalidad del mercado.
// El styling vive en mici-ui.css bajo .px-marker / .px-marker-dot / .px-marker-ring
// (mismas clases que el preview).
const FALLBACK_COLOR = "#808080";

const getModalidadColor = (idEstado, idModalidad) => {
  const estado = COLORS_MERCADOS[Number(idEstado)];
  if (!estado || !estado.modalidades) return FALLBACK_COLOR;
  const mod = estado.modalidades[Number(idModalidad)];
  return (mod && mod.color) || FALLBACK_COLOR;
};

// Cache de L.divIcon por (idEstado, idModalidad). Sin esto cada render de un
// <Marker> generaba un divIcon nuevo (referencia distinta), y react-leaflet
// re-creaba el elemento DOM al detectar el cambio de prop — eso era el blink
// que se veía cuando parques/zonas terminaban sus fetchs y disparaban un
// re-render del árbol completo. Mismo (estado, modalidad) → misma instancia.
const _mercadoIconCache = new Map();

export const getMercadoMinoristaIcon = (idEstadoIntervencion, idModalidad) => {
  const key = `${idEstadoIntervencion}|${idModalidad}`;
  const cached = _mercadoIconCache.get(key);
  if (cached) return cached;

  const color = getModalidadColor(idEstadoIntervencion, idModalidad);
  // iconAnchor en bottom-center (14, 28) — replica el offset del icon legacy
  // PNG que estaba a [12, 30] sobre un 25×30. Con esto el dot/ring visible
  // queda ~14 px arriba de la coordenada geográfica, igual que el legacy.
  // Si lo cambias a [14, 14] (center) los markers se desplazan ~14 px al sur,
  // lo que puede hacerlos "saltar" al mar para coordenadas costeras.
  const icon = L.divIcon({
    className: "px-marker",
    html:
      `<span class="px-marker-ring" style="--c:${color}"></span>` +
      `<span class="px-marker-dot" style="background:${color}"></span>`,
    iconSize: [28, 28],
    iconAnchor: [14, 28],
    popupAnchor: [0, -28],
  });
  _mercadoIconCache.set(key, icon);
  return icon;
};

export const icons = {
  "ZONAS INDUSTRIALES": createIcon(zonas_industriales),
  "PARQUES INDUSTRIALES": createIcon(parques_industriales),
  default: createIcon(minoristaVerde),
};